import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '@app/core/services/custom-services/configuration.service';
import { IMarketDTO } from '@app/core/models/tactical/market/market-dto.model';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { KendoGridService } from '@app/core/services/custom-services/kendo-grid.service';

@Injectable({
  providedIn: 'root',
})
export class MarketService {

  private readonly kendoGridService = inject(KendoGridService);
  private readonly http = inject(HttpClient);
  private readonly conf = inject(ConfigurationService);

  query(state: State): Observable<GridDataResult> {
    let params = new HttpParams();

    if (state) {
      const stateFilter = this.kendoGridService.getStateFilter(state);

      stateFilter?.filter?.forEach((element) => {
        params = params.append(element.code, element.value);
      });
      params = params.set('skip', stateFilter.skip).set('take', stateFilter.take);
    }

    return this.http.get<GridDataResult>(`${this.conf.baseApiUrl}tactical/market`, { params });
  }

  save(market: IMarketDTO): Observable<void> {
    return this.http.post<void>(`${this.conf.baseApiUrl}tactical/market`, market);
  }

  update(market: IMarketDTO): Observable<IMarketDTO> {
    return this.http.put<IMarketDTO>(`${this.conf.baseApiUrl}tactical/market`, market);
  }

  remove(marketId: string): Observable<void> {
    return this.http.delete<void>(`${this.conf.baseApiUrl}tactical/market/${marketId}`);
  }
}
